var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row"},[_c('v-btn',{staticClass:"ma-2",attrs:{"icon":"","disabled":_vm.loading},on:{"click":_vm.open}},[_c('v-icon',[_vm._v("fal fa-ellipsis-v")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }